import { createContext, useState } from "react";
import useLoggerHook from "../../hooks/useLoggerHook";

// Types
type TAuthContextProviderProps = {
  children: React.ReactNode;
};

type TUserAgency = {
  agencyName: string;
  badgeNumber: string;
  roles: string[];
  uid: string;
};

type TUserUMC = {
  firstName: string;
  lastName: string;
  provinceSom: string;
  roles: string[];
  uid: string;
};

// Local Enums

// const ErrorsEnum: { [key: string]: string } = {
//     AUTHENTICATION_FAILED: "AUTHENTICATION_FAILED"
// };

// const ErrorsMap: any = {
//     [ErrorsEnum.AUTHENTICATION_FAILED]: {
//         key: [ErrorsEnum.AUTHENTICATION_FAILED],
//         message: "User authentication failed"
//     },
// };

// Create initial empty context
const AuthContext = createContext<any | null>(null);

/**
 * Main app context
 * @param {*} props
 * @returns
 */
const AuthContextProvider = ({ children }: TAuthContextProviderProps) => {
//   const [debugConsoleLog] = useLoggerHook();

  const [userState, setUserState] = useState<TUserAgency | TUserUMC>({
    firstName: "",
    lastName: "",
    provinceSom: "",
    roles: [],
    uid: "",
  });

  /**
   * Initializes a new user object
   * @access private
   */
  // const _initUserState = (data: any) => {
  //     return null;
  // };

  /**
   * Returns a boolean value indicating whether the current user is in the specified role.
   * The function is only intended to work with values from the enumeration `ENUM_ROLES` from AuthContext.
   * @param {String} role The name of the role to search for.
   * @returns {Boolean} true if the current user is in the specified role; otherwise, false.
   * @access public
   */
  const isInRole = (role: string) => {
    // if (userState.roles.includes(role)) {
    //     return true;
    // }
    // return false;
    return true;
  };

  /**
   * Call to auth API
   *
   */
  // useEffect(() => {
  //     const UserDetailsObservable = AuthService
  //         .userDetails({})
  //         .pipe(
  //             tap(() => {
  //                 setAuthStateContainerStatus(ENUM_CONTAINER_STATUS.LOADING);
  //             }),
  //             map((data) => {
  //                 const user: TUserAgency | TUserUMC | null = _initUserState(data);

  //                 if (user === null) {
  //                     throw new Error(ErrorsMap[ErrorsEnum.AUTHENTICATION_FAILED].message);
  //                 }
  //                 return user;
  //             })
  //         )
  //         .subscribe({
  //             next: (user) => {
  //                 setUserState(user);
  //                 setAuthStateContainerStatus(ENUM_CONTAINER_STATUS.SUCCESS);
  //             },
  //             error: (err) => {
  //                 debugConsoleLog(err.message);
  //                 setAuthStateContainerStatus(ENUM_CONTAINER_STATUS.ERROR);
  //             }
  //         });

  //     return () => {
  //         UserDetailsObservable.unsubscribe();
  //     };

  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <AuthContext.Provider
      value={{
        user: userState,
        isInRole: isInRole,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
export { AuthContext };
